export enum EOpenPoseBodyGroup {
  /*
   * HIPS
   */
  HIP_LEFT_INNER = 'hip_left_inner',
  HIP_RIGHT_INNER = 'hip_right_inner',

  /*
   * SHOULDERS
   */
  SHOULDER_LEFT_INNER = 'shoulder_left_inner',
  SHOULDER_RIGHT_INNER = 'shoulder_right_inner',

  /*
   * TORSO
   */
  TORSO = 'torso',
}
